/**
 * MARKA DEVRALIM ZİNCİRİ — TEK KAYNAK (Faz 4 · Story 23.3 · karar P11).
 *
 * `etkinlik markası ?? kurum markası ?? platform varsayılanı`
 *
 * Zincir YALNIZCA burada çözülür. Panel, public etkinlik sayfası ve yaka kartı
 * aynı fonksiyonu çağırır; hiçbir tüketici kendi `??` zincirini yazmaz. Üç yerde
 * ayrı `if` yazılsaydı üçü zamanla ayrışırdı — `brand-surface-inventory.guard`
 * bunu makineyle yasaklar (yeni bir yüzey zincirden geçmeden marka okursa test
 * KIRILIR).
 *
 * KARARLAR:
 *  - **B1 · CANLI REFERANS.** Snapshot YOKTUR: kurum logosu/rengi değişince
 *    ezmemiş TÜM etkinlikler (geçmiş + gelecek) birden değişir. Zincir her
 *    okumada yeniden çözülür, hiçbir yere kopyalanmaz.
 *  - **B5 · ÜÇÜNCÜ DURUM YOK.** `null` = DEVRAL. "Hiç marka olmasın" diye bir
 *    durum yoktur; renk her zaman çözülür (en kötü ihtimalle platform tonu).
 *  - **ALAN BAZINDA devralım (bilinçli).** Logo ve renk AYRI AYRI çözülür:
 *    yalnız rengini ezen bir etkinlik kurumun logosunu devralmaya devam eder.
 *    Bu B5'i delmez — her alan için hâlâ iki durum vardır (ez ya da devral).
 *  - **P8 · Platform çerçevesi sabit.** Buradan dönen değer YALNIZCA içerik
 *    alanında kullanılır: navigasyon, alt sekme, sistem düğmesi ve hata renkleri
 *    bu zincire bağlanamaz.
 */
import { contrastRatio } from '../design/contrast';
import { defaultBrand } from '../design/tokens';
/**
 * Marka rengi paleti — referans "Icebrkr Organizatör - Panel ve Check-in.dc.html"
 * satır 934 (`brandColors`), ekran 23 bölüm 4'te 56×56 kutular hâlinde çizili.
 *
 * KAPALI KÜME: renk serbest girilmez, referanstaki beş tondan seçilir. Kurum
 * paleti de BUDUR (karar B3: "ikinci bir renk sistemi icat edilmez") — kurum
 * ekranı ve etkinlik ekranı aynı diziyi okur.
 */
export const BRAND_COLOR_PALETTE = ['#EC3013', '#1F4ED8', '#0D7A5F', '#7C3AED', '#201E1D'];
/**
 * KURUM GÜNCELLEME UCUNDA MARKA SAYILAN ALANLAR (Blok 29 · B2).
 *
 * Bu küme yetki kapısını AYIRIR: yalnızca bu alanlara dokunan bir istek
 * `organization:brand_manage` (owner + admin) ister; kümenin DIŞINDAN tek bir
 * alan bile gelirse istek `organization:manage` (yalnız owner) ister.
 * Sunucu kapısı ve istemcinin salt okunur çizimi AYNI listeden okur.
 *
 * `coverMediaId` (kurum kapak görseli, kullanıcı kararı 14.10.2026): kapağı sahip
 * VE yönetici değiştirir, Marka sekmesinde durur. Kapak marka ZİNCİRİNİN halkası
 * DEĞİLDİR (etkinliğe devralınmaz, `BrandLayer` taşımaz); bu küme zinciri değil
 * yetki kapısını ve denetim değerlerini tanımlar.
 */
export const ORGANIZATION_BRAND_FIELDS = ['logoMediaId', 'brandColor', 'coverMediaId'];
/**
 * ETKİNLİK GÜNCELLEME UCUNDA MARKA SAYILAN ALANLAR (Blok 30 · Story 23.1).
 *
 * Kardeşi `ORGANIZATION_BRAND_FIELDS` ile AYNI KATMANDA durur (tech-lead Blok 30
 * · Düşük-1): küme önce yalnız API'de tanımlıydı ve aynı iki alan adı depoda üç
 * ayrı yerde yazılıydı. Etkinlik tarafında bu küme YETKİ KAPISI AYIRMAZ (marka
 * yazma kapısı = etkinlik güncelleme kapısı, `event:manage`); DENETİM
 * DEFTERİNDE hangi alanların DEĞER olarak yazılacağını belirler (KÇ 5).
 */
export const EVENT_BRAND_FIELDS = ['brandLogoMediaId', 'brandColor'];
/**
 * MARKA EKRANININ YAZDIĞI ALANLAR (Tur T10) — zincir + KAPAK.
 *
 * `EVENT_BRAND_FIELDS` denetim defterinin kümesidir ve DEĞİŞMEZ (kapak marka
 * zincirinin halkası değildir: devralınmaz, etkinliğin kendi görselidir).
 * Ama EKRAN üçünü birden yazar (referans ekran 09: "Kurum logosu · Kapak
 * görseli · Marka rengi"), bu yüzden ekranın kümesi ayrıca TÜRETİLİR.
 */
export const EVENT_BRAND_SCREEN_FIELDS = [...EVENT_BRAND_FIELDS, 'coverMediaId'];
/**
 * Verilen yama YALNIZCA marka EKRANININ alanlarına mı dokunuyor? (boş = hayır)
 *
 * NEDEN VAR (Tur T10): marka ekranı ve kurulum ekranı AYNI ucu kullanıyor
 * (`PATCH /events/:id`) ve mobilde ikisi ayrı bölüm. Kurulum dilimi her
 * `events/update` başarısında künye taslağını sunucudan GERİ YAZIYOR; marka
 * kaydı da o dala düşseydi, kullanıcının kaydetmediği künye düzenlemesi
 * sessizce silinirdi. Ayrım alan kümesinden TÜRETİLİR, elle liste yazılmaz.
 */
export function isEventBrandScreenPatch(keys) {
    return (keys.length > 0 &&
        keys.every((key) => EVENT_BRAND_SCREEN_FIELDS.includes(key)));
}
/** Verilen yama YALNIZCA marka alanlarına mı dokunuyor? (boş yama = hayır) */
export function isBrandOnlyPatch(keys) {
    return (keys.length > 0 &&
        keys.every((key) => ORGANIZATION_BRAND_FIELDS.includes(key)));
}
/** Zincirin hangi halkasından geldiği — ekran "devralıyor mu, eziyor mu" der. */
export const BRAND_SOURCES = ['event', 'organization', 'platform'];
/** Metin/dolgu eşiği — WCAG AA normal metin. */
const AA_TEXT_RATIO = 4.5;
/** Koyulaştırma adımı (her adımda kanalların %8'i düşer). */
const DARKEN_STEP = 0.08;
const MAX_DARKEN_STEPS = 12;
function clampChannel(value) {
    return Math.max(0, Math.min(255, Math.round(value)));
}
function toHex(r, g, b) {
    return `#${[r, g, b].map((c) => clampChannel(c).toString(16).padStart(2, '0')).join('')}`.toUpperCase();
}
function parseHex(color) {
    const normalized = color.replace('#', '').trim();
    const full = normalized.length === 3
        ? normalized
            .split('')
            .map((c) => c + c)
            .join('')
        : normalized;
    if (!/^[0-9a-fA-F]{6}$/.test(full))
        return null;
    return {
        r: parseInt(full.slice(0, 2), 16),
        g: parseInt(full.slice(2, 4), 16),
        b: parseInt(full.slice(4, 6), 16),
    };
}
/**
 * AA DÜŞÜRMESİ — TEK HESAP (Story 23.1 ve 23.3 aynı fonksiyonu çağırır).
 *
 * "Seçtiğiniz renk metin üzerinde AA kontrast vermezse sistem otomatik olarak
 * koyu bir tonu kullanır" (referans ekran 23 bölüm 5). Hesap web'de, public
 * sayfada ve yaka kartında AYNI sonucu vermek zorundadır; bu yüzden ikinci bir
 * kopyası YAZILMAZ.
 *
 * Bugünkü palette yalnız `#EC3013` (4,20:1) eşiğin altındadır — kural teorik
 * değil, gerçek bir vakası olan bir kuraldır.
 */
export function accessibleBrandColor(color, 
/** Bozuk hex'te düşülecek ton; verilmezse kod adı varsayılanı (yalnız test). */
fallback = defaultBrand.primary) {
    const rgb = parseHex(color);
    if (!rgb)
        return { color: fallback, adjusted: true };
    let current = { ...rgb };
    for (let step = 0; step < MAX_DARKEN_STEPS; step += 1) {
        const hex = toHex(current.r, current.g, current.b);
        if (contrastRatio('#FFFFFF', hex) >= AA_TEXT_RATIO) {
            return { color: hex, adjusted: step > 0 };
        }
        current = {
            r: current.r * (1 - DARKEN_STEP),
            g: current.g * (1 - DARKEN_STEP),
            b: current.b * (1 - DARKEN_STEP),
        };
    }
    // Teorik olarak ulaşılmaz (siyaha yaklaşır); yine de sessiz kalmayız.
    return { color: '#000000', adjusted: true };
}
/**
 * ZİNCİRİ ÇÖZ. Girdi HAM halkalar, çıktı tek bir çözülmüş markadır.
 *
 * `event` bugün (Blok 29) etkinlik marka kolonlarından, `organization` kurum
 * kolonlarından gelir. Halka verilmezse (`undefined`) o halka atlanır — çağıran
 * "kurumu bilmiyorum" ile "kurumun markası yok"u ayırmak zorunda kalmaz, ikisi
 * de devralımın bir sonraki halkasına düşer.
 */
export function resolveBrandChain(input) {
    const layers = [
        ['event', input.event],
        ['organization', input.organization],
    ];
    let logoMediaId = null;
    let logoUrl = null;
    let logoSource = 'platform';
    let color = null;
    let colorSource = 'platform';
    for (const [source, layer] of layers) {
        if (logoMediaId === null && layer?.logoMediaId) {
            logoMediaId = layer.logoMediaId;
            logoUrl = layer.logoUrl;
            logoSource = source;
        }
        if (color === null && layer?.color) {
            color = layer.color;
            colorSource = source;
        }
    }
    const effectiveColor = color ?? input.platform;
    const accessible = accessibleBrandColor(effectiveColor, input.platform);
    return {
        logoMediaId,
        logoUrl,
        logoSource,
        color: effectiveColor,
        colorSource,
        accessibleColor: accessible.color,
        contrastAdjusted: accessible.adjusted,
    };
}
/**
 * KURUM İŞARETİNİN MARKA ZEMİNİ — TEK KURAL (organizatör sayfası, 14.10.2026).
 *
 * Kurumun KENDİ rengi varsa zincirden çözülmüş, beyaz yazıyla AA veren ton
 * (`accessibleColor`); yoksa `null` ve organizatör işareti ink zemine düşer
 * (`organizationMarkTone`). Sunucunun `EventOrganizerDto.brandFill`i ve kurum ayarları başlığı
 * aynı fonksiyondan geçer: aynı kurum her yüzeyde aynı tonda görünür. Etkinlik
 * markası karışmaz (B-18), logo verilmez (logo varsa çağıran logoyu çizer).
 */
export function organizationMarkFill(platform, organization) {
    const brand = resolveBrandChain({
        platform,
        organization: { logoMediaId: null, logoUrl: null, color: organization.brandColor },
    });
    return brand.colorSource === 'organization' ? brand.accessibleColor : null;
}
/**
 * ÇÖZÜLMÜŞ MARKADAN KURUM İŞARETİNİN ZEMİNİ (künye, marka düzenleme önizlemesi).
 * Zemin yalnız kurumun KENDİ rengidir: zincir platform ya da etkinlik tonuna
 * düştüyse `null` döner ve işaret ink zemine düşer (`organizationMarkTone`).
 * `organizationMarkFill`in çözülmüş marka eşidir; iki yol aynı tonu verir.
 */
export function organizationMarkFillFromBrand(brand) {
    return brand.colorSource === 'organization' ? brand.accessibleColor : null;
}
export function organizationMarkTone(input) {
    if (input.logoUrl)
        return { kind: 'logo' };
    if (input.fill)
        return { kind: 'brand', fill: input.fill };
    return { kind: 'ink' };
}
/**
 * Zincirin herhangi bir halkasında GERÇEK bir marka var mı?
 *
 * Yayın kontrol listesindeki "Marka logosu yüklenmedi" satırı bunu okur —
 * sabit uyarı DEĞİL, gerçek durum (Story 23.1 kabul kriteri).
 */
export function hasBrandLogo(brand) {
    return brand.logoMediaId !== null;
}
/** Etkinlik kendi markasıyla kurumunkini eziyor mu (ekranın "eziyor" satırı)? */
export function isBrandOverridden(brand) {
    return brand.logoSource === 'event' || brand.colorSource === 'event';
}
//# sourceMappingURL=brand.js.map